import { Component, OnInit, Input } from '@angular/core';
import { Project } from '../../models/project';

@Component({
  selector: 'cw-project-info-small',
  templateUrl: './project-info-small.component.html',
})
export class ProjectInfoSmallComponent implements OnInit {
  @Input() project: Project;

  constructor() {
  }

  ngOnInit() {
    console.log(this.project);
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/project-info-small/project-info-small.component.ts